import { useTranslation } from 'react-i18next';
import { BoldLabelFormItem } from 'components/form/BoldLabelFormItem';
import { Row, Col, Grid } from 'antd';
import useFormInstance from 'antd/es/form/hooks/useFormInstance';
import { useRequestDropDown, useBankCode, useIdType } from 'all-in-one-shared-api';
// import TextArea from 'antd/es/input/TextArea';
// import { Spinner } from 'components';
import React, { useEffect, useState } from 'react';
import { useKeycloakReady } from 'hooks/useKeycloakReady';
import redright from 'assets/images/redright.svg';
// import { useNavigate } from 'react-router-dom';
import { isLocaleEnglish } from 'utils/languageUtils';
// import Visibility from 'assets/images/eye-open.svg';
// import VisibilityOff from 'assets/images/eye-off.svg';
// import {
//   formatCardNumber2,
//   formatCardNumber4
// } from 'utils/formate/cardNumber';
const { useBreakpoint } = Grid;

// import styled from 'styled-components';
export const PaymentInfomationCard = (props: { downloadServiceFormEn?: string; downloadServiceFormTc?: string }) => {
  const { t, i18n } = useTranslation();
  const form = useFormInstance();
  const { token } = useKeycloakReady();
  // const navigate = useNavigate();
  // const [idTypedefult, setidType] = useState('');
  const [bankdefult, setbankdefult] = useState('');
  const isEnglish = isLocaleEnglish(i18n.language);

  // const [showCardMask, setShowCardMask] = useState<boolean>(true);
  // const [showCardNoMask, setShowCardNoMask] = useState<boolean>(true);
  const { xs } = useBreakpoint();

  const { data: bankList, shouldFetch: shouldFetchBankList } = useBankCode(token || '');
  const { data: idType, shouldFetch: shouldFetchIdType } = useIdType(token || '');
  const {
    shouldFetch: shouldFecthDrop,
    data: dropData,
    // isLoading: dropDataisLoading,
  } = useRequestDropDown('useRequestDropDown', token || '');
  const policyTypesObject: { label: string; label2: string; value: string }[] = [];
  useEffect(() => {
    shouldFecthDrop(true);
  }, [shouldFecthDrop]);
  const dropDatanew = dropData?.filter((item) =>
    form.getFieldValue('correspondencePolicyNo')?.includes(item.policyNumber),
  );
  dropDatanew?.map((item) => {
    policyTypesObject.push({
      label: i18n.language == 'en' ? item.productName : item.productNameTC,
      label2: `${t('life.enquiry.policyNo')}${item.policyNumber}`,
      value: item.policyNumber,
    });
  });
  useEffect(() => {
    shouldFetchIdType(true);
  }, [shouldFetchIdType]);
  useEffect(() => {
    shouldFetchBankList(true);
  }, [shouldFetchBankList]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const myBankList: { label: string; value: string }[] = [];
  bankList?.banks?.map((item: { bankCode: string; bankName: string; bankNameTc: string }) => {
    myBankList.push({
      label: `${item.bankCode}-${isEnglish ? item.bankName : item.bankNameTc}`,
      value: item.bankCode,
    });
  });
  const downloadPdf = () => {
    if (isEnglish) {
      if (props.downloadServiceFormEn) {
        const link = document.createElement('a');
        const url = props.downloadServiceFormEn;
        link.href = url;
        link.target = '_blank';
        link.rel = 'noreferrer';
        link.download = 'filename.pdf';
        document.body.appendChild(link);
        // link.click();
        const e = document.createEvent('MouseEvent');
        e.initEvent('click', false, false);
        link.dispatchEvent(e);
      }
    } else {
      if (props.downloadServiceFormTc) {
        const link = document.createElement('a');
        const url = props.downloadServiceFormTc;
        link.href = url;
        link.target = '_blank';
        link.rel = 'noreferrer';
        link.download = 'filename.pdf';
        document.body.appendChild(link);
        // link.click();
        const e = document.createEvent('MouseEvent');
        e.initEvent('click', false, false);
        link.dispatchEvent(e);
      }
    }
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const idTypeList: { label: string; value: string }[] = [];
  idType?.map((item: { idTypeDesc: string; idTypeDescTc: string; idType: string }) => {
    idTypeList.push({
      label: isEnglish ? item.idTypeDesc : item.idTypeDescTc,
      value: item.idType,
    });
  });
  useEffect(() => {
    const a = myBankList?.find((item) => item.value === form.getFieldValue('bankCode'))?.label;
    if (a) {
      setbankdefult(a);
    } else {
      setbankdefult(form.getFieldValue('bankCode'));
    }
    // eslint-disable-line react-hooks/exhaustive-deps
  }, [myBankList, form]);
  return (
    <div>
      <Row justify="center" gutter={[16, { xs: 8, sm: 8, lg: 24 }]} style={{ rowGap: 0 }}>
        <Col xs={24} md={24}>
          <BoldLabelFormItem
            label={
              <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto500' }}>
                {t('life.MakeRequest.payment.Paymentmode')}
              </span>
            }
            name="paymentMode"
          >
            <div
              style={{
                border: 'none',
                borderBottom: '1px solid #CCCCCC',
                // color: "white",
                backgroundColor: 'transparent',
                fontSize: '20px',
                fontFamily: 'Roboto400',
                marginBottom: '10px',
                padding: '4px 0',
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              <div style={{ width: form.getFieldValue('paymentModeFlag') === 'Y' ? (xs ? '70%' : '80%') : '100%' }}>
                {isEnglish ? form.getFieldValue('paymentMode') : form.getFieldValue('paymentModeTc')}
              </div>
              {form.getFieldValue('paymentModeFlag') === 'Y' && (
                <div
                  style={{
                    background: '#E9573D',
                    borderRadius: '20px',
                    padding: '4px 8px',
                    fontSize: '15px',
                    fontFamily: 'Roboto700',
                    color: '#FFF',
                    height: '31.5px',
                    // minWidth: '91px',
                  }}
                >
                  {t('life.MakeRequest.contact.UnderReview')}
                </div>
              )}
            </div>
          </BoldLabelFormItem>
        </Col>
        <Col xs={24} md={24}>
          <BoldLabelFormItem
            label={
              <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto500' }}>
                {t('life.MakeRequest.payment.Renewal')}
              </span>
            }
            name="Renewal"
          >
            <div
              style={{
                border: 'none',
                borderBottom: '1px solid #CCCCCC',
                // color: "white",
                backgroundColor: 'transparent',
                fontSize: '20px',
                fontFamily: 'Roboto400',
                marginBottom: '10px',
                padding: '4px 0',
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              <div style={{ width: form.getFieldValue('paymentMethodFlag') === 'Y' ? (xs ? '70%' : '80%') : '100%' }}>
                {/* {form.getFieldValue('RenewalPaymentMethod')} */}
                {isEnglish ? form.getFieldValue('RenewalPaymentMethod') : form.getFieldValue('RenewalPaymentMethodTc')}
              </div>
              {form.getFieldValue('paymentMethodFlag') === 'Y' && (
                <div
                  style={{
                    background: '#E9573D',
                    borderRadius: '20px',
                    padding: '4px 8px',
                    fontSize: '15px',
                    fontFamily: 'Roboto700',
                    color: '#FFF',
                    height: '31.5px',
                    // minWidth: '91px',
                  }}
                >
                  {t('life.MakeRequest.contact.UnderReview')}
                </div>
              )}
            </div>
          </BoldLabelFormItem>
        </Col>
      </Row>
      {form.getFieldValue('paymentMethoddf') == 'V' && (
        <Row justify="center" gutter={[16, { xs: 8, sm: 8, lg: 24 }]} style={{ rowGap: 0 }}>
          <Col xs={24} md={24}>
            <BoldLabelFormItem
              label={
                <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto500' }}>
                  {t('life.MakeRequest.payment.CreditCardNumber')}
                </span>
              }
              name="CreditCard"
            >
              <div
                style={{
                  border: 'none',
                  borderBottom: '1px solid #CCCCCC',
                  // color: "white",
                  backgroundColor: 'transparent',
                  fontSize: '20px',
                  fontFamily: 'Roboto400',
                  marginBottom: '10px',
                  padding: '4px 0',
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <div style={{ width: form.getFieldValue('cardNoFlag') === 'Y' ? (xs ? '65%' : '75%') : '100%' }}>
                  {
                    // showCardNoMask
                    //   ? formatCardNumber4(form.getFieldValue('CreditCard'))
                    //   :
                    form.getFieldValue('CreditCard')
                  }
                </div>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  {/* {showCardNoMask ? (
                    <img
                      style={{ marginRight: form.getFieldValue('cardNoFlag') === 'Y' ? '10px' : '0' }}
                      src={Visibility}
                      onClick={() => setShowCardNoMask(!showCardNoMask)}
                    />
                  ) : (
                    <img
                      style={{ marginRight: form.getFieldValue('cardNoFlag') === 'Y' ? '10px' : '0' }}
                      src={VisibilityOff}
                      onClick={() => setShowCardNoMask(!showCardNoMask)}
                    />
                  )} */}

                  {form.getFieldValue('cardNoFlag') === 'Y' && (
                    <div
                      style={{
                        background: '#E9573D',
                        borderRadius: '20px',
                        padding: '4px 8px',
                        fontSize: '15px',
                        fontFamily: 'Roboto700',
                        color: '#FFF',
                        height: '31.5px',
                        // minWidth: '91px',
                      }}
                    >
                      {t('life.MakeRequest.contact.UnderReview')}
                    </div>
                  )}
                </div>
              </div>
            </BoldLabelFormItem>
          </Col>
          <Col xs={24} md={24}>
            <BoldLabelFormItem
              label={
                <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto500' }}>
                  {t('life.MakeRequest.payment.CreditCardDate')}
                </span>
              }
              name="expiryDate"
            >
              <div
                style={{
                  border: 'none',
                  borderBottom: '1px solid #CCCCCC',
                  // color: "white",
                  backgroundColor: 'transparent',
                  fontSize: '20px',
                  fontFamily: 'Roboto400',
                  marginBottom: '10px',
                  padding: '4px 0',
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <div
                  style={{
                    width: form.getFieldValue('creditCardExpiryDateFlag') === 'Y' ? (xs ? '70%' : '80%') : '100%',
                  }}
                >
                  {form.getFieldValue('expiryDate') == '' ? '—' : form.getFieldValue('expiryDate')}
                </div>
                {form.getFieldValue('creditCardExpiryDateFlag') === 'Y' && (
                  <div
                    style={{
                      background: '#E9573D',
                      borderRadius: '20px',
                      padding: '4px 8px',
                      fontSize: '15px',
                      fontFamily: 'Roboto700',
                      color: '#FFF',
                      height: '31.5px',
                      // minWidth: '91px',
                    }}
                  >
                    {t('life.MakeRequest.contact.UnderReview')}
                  </div>
                )}
              </div>
            </BoldLabelFormItem>
          </Col>
          <Col xs={24} md={24}>
            <BoldLabelFormItem
              label={
                <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto500' }}>
                  {t('life.MakeRequest.payment.AutopayStatus')}
                </span>
              }
              name="AutopayStatus"
            >
              <div
                style={{
                  border: 'none',
                  borderBottom: '1px solid #CCCCCC',
                  // color: "white",
                  backgroundColor: 'transparent',
                  fontSize: '20px',
                  fontFamily: 'Roboto400',
                  marginBottom: '10px',
                  padding: '4px 0',
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <div style={{ width: form.getFieldValue('officeNumberFlag') === 'Y' ? (xs ? '70%' : '80%') : '100%' }}>
                  {isEnglish ? form.getFieldValue('AutopayStatus') : form.getFieldValue('AutopayStatusTc')}
                </div>
                {form.getFieldValue('officeNumberFlag') === 'Y' && (
                  <div
                    style={{
                      background: '#E9573D',
                      borderRadius: '20px',
                      padding: '4px 8px',
                      fontSize: '15px',
                      fontFamily: 'Roboto700',
                      color: '#FFF',
                      height: '31.5px',
                      // minWidth: '91px',
                    }}
                  >
                    {t('life.MakeRequest.contact.UnderReview')}
                  </div>
                )}
              </div>
            </BoldLabelFormItem>
          </Col>
        </Row>
      )}
      {form.getFieldValue('paymentMethoddf') == 'D' && (
        <Row justify="center" gutter={[16, { xs: 8, sm: 8, lg: 24 }]} style={{ rowGap: 0 }}>
          <Col xs={24} md={24}>
            <BoldLabelFormItem
              label={
                <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto500' }}>
                  {t('life.MakeRequest.payment.BankCode')}
                </span>
              }
              name="BankCode"
            >
              <div
                style={{
                  border: 'none',
                  borderBottom: '1px solid #CCCCCC',
                  // color: "white",
                  backgroundColor: 'transparent',
                  fontSize: '20px',
                  fontFamily: 'Roboto400',
                  marginBottom: '10px',
                  padding: '4px 0',
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <div style={{ width: form.getFieldValue('branchCodeFlag') === 'Y' ? (xs ? '70%' : '80%') : '100%' }}>
                  {bankdefult}
                </div>
                {form.getFieldValue('branchCodeFlag') === 'Y' && (
                  <div
                    style={{
                      background: '#E9573D',
                      borderRadius: '20px',
                      padding: '4px 8px',
                      fontSize: '15px',
                      fontFamily: 'Roboto700',
                      color: '#FFF',
                      height: '31.5px',
                      // minWidth: '91px',
                    }}
                  >
                    {t('life.MakeRequest.contact.UnderReview')}
                  </div>
                )}
              </div>
            </BoldLabelFormItem>
          </Col>

          <Col xs={24} md={24}>
            <BoldLabelFormItem
              label={
                <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto500' }}>
                  {t('life.MakeRequest.payment.BranchNumber')}
                </span>
              }
              name="branchNumber"
            >
              <div
                style={{
                  border: 'none',
                  borderBottom: '1px solid #CCCCCC',
                  // color: "white",
                  backgroundColor: 'transparent',
                  fontSize: '20px',
                  fontFamily: 'Roboto400',
                  marginBottom: '10px',
                  padding: '4px 0',
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <div style={{ width: form.getFieldValue('branchNumberFlag') === 'Y' ? (xs ? '70%' : '80%') : '100%' }}>
                  {form.getFieldValue('branchNumber')}
                </div>
                {form.getFieldValue('branchNumberFlag') === 'Y' && (
                  <div
                    style={{
                      background: '#E9573D',
                      borderRadius: '20px',
                      padding: '4px 8px',
                      fontSize: '15px',
                      fontFamily: 'Roboto700',
                      color: '#FFF',
                      height: '31.5px',
                      // minWidth: '91px',
                    }}
                  >
                    {t('life.MakeRequest.contact.UnderReview')}
                  </div>
                )}
              </div>
            </BoldLabelFormItem>
          </Col>

          <Col xs={24} md={24}>
            <BoldLabelFormItem
              label={
                <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto500' }}>
                  {t('life.MakeRequest.payment.BankAccountNumber')}
                </span>
              }
              name="bankAccountNumber"
            >
              <div
                style={{
                  border: 'none',
                  borderBottom: '1px solid #CCCCCC',
                  // color: "white",
                  backgroundColor: 'transparent',
                  fontSize: '20px',
                  fontFamily: 'Roboto400',
                  marginBottom: '10px',
                  padding: '4px 0',
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                {/* {form.getFieldValue('bankAccountNumber')} */}
                <div
                  className="bankAccountNumber"
                  style={{ width: form.getFieldValue('bankAccountFlag') === 'Y' ? (xs ? '65%' : '75%') : '100%' }}
                >
                  {
                    // showCardMask
                    //   ? formatCardNumber2(form.getFieldValue('bankAccountNumber'))
                    //   :
                    form.getFieldValue('bankAccountNumber')
                  }
                </div>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  {/* {showCardMask ? (
                    <img
                      style={{ marginRight: form.getFieldValue('bankAccountFlag') === 'Y' ? '10px' : '0' }}
                      src={Visibility}
                      onClick={() => setShowCardMask(!showCardMask)}
                    />
                  ) : (
                    <img
                      style={{ marginRight: form.getFieldValue('bankAccountFlag') === 'Y' ? '10px' : '0' }}
                      src={VisibilityOff}
                      onClick={() => setShowCardMask(!showCardMask)}
                    />
                  )} */}
                  {form.getFieldValue('bankAccountFlag') === 'Y' && (
                    <div
                      style={{
                        background: '#E9573D',
                        borderRadius: '20px',
                        padding: '4px 8px',
                        fontSize: '15px',
                        fontFamily: 'Roboto700',
                        color: '#FFF',
                        height: '31.5px',
                        // minWidth: '91px',
                      }}
                    >
                      {t('life.MakeRequest.contact.UnderReview')}
                    </div>
                  )}
                </div>
              </div>
            </BoldLabelFormItem>
          </Col>
          {/* <Col xs={24} md={24}>
            <BoldLabelFormItem
              label={
                <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto500' }}>
                  {t('life.MakeRequest.payment.AccountHolderName')}
                </span>
              }
              name="accountHolder"
            >
              <div
                style={{
                  border: 'none',
                  borderBottom: '1px solid #CCCCCC',
                  // color: "white",
                  backgroundColor: 'transparent',
                  fontSize: '20px',
                  fontFamily: 'Roboto400',
                  marginBottom: '10px',
                  padding: '4px 0',
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                {form.getFieldValue('accountHolder')}
                {form.getFieldValue('accountHolderFlag') === 'Y' && (
                  <div
                    style={{
                      background: '#E9573D',
                      borderRadius: '20px',
                      padding: '4px 8px',
                      fontSize: '15px',
                      fontFamily: 'Roboto700',
                      color: '#FFF',
                    }}
                  >
                    {t('life.MakeRequest.contact.UnderReview')}
                  </div>
                )}
              </div>
            </BoldLabelFormItem>
          </Col>
          <Col xs={24} md={24}>
            <BoldLabelFormItem
              label={
                <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto500' }}>
                  {t('life.MakeRequest.payment.IDType')}
                </span>
              }
              name="IDType"
            >
              <div
                style={{
                  border: 'none',
                  borderBottom: '1px solid #CCCCCC',
                  // color: "white",
                  backgroundColor: 'transparent',
                  fontSize: '20px',
                  fontFamily: 'Roboto400',
                  marginBottom: '10px',
                  padding: '4px 0',
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                {idTypedefult}
                {form.getFieldValue('IDTypeFlag') === 'Y' && (
                  <div
                    style={{
                      background: '#E9573D',
                      borderRadius: '20px',
                      padding: '4px 8px',
                      fontSize: '15px',
                      fontFamily: 'Roboto700',
                      color: '#FFF',
                    }}
                  >
                    {t('life.MakeRequest.contact.UnderReview')}
                  </div>
                )}
              </div>
            </BoldLabelFormItem>
          </Col>
          <Col xs={24} md={24}>
            <BoldLabelFormItem
              label={
                <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto500' }}>
                  {t('life.MakeRequest.payment.IDCard')}
                </span>
              }
              name="passport"
            >
              <div
                style={{
                  border: 'none',
                  borderBottom: '1px solid #CCCCCC',
                  // color: "white",
                  backgroundColor: 'transparent',
                  fontSize: '20px',
                  fontFamily: 'Roboto400',
                  marginBottom: '10px',
                  padding: '4px 0',
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                {form.getFieldValue('passport')}
                {form.getFieldValue('passportFlag') === 'Y' && (
                  <div
                    style={{
                      background: '#E9573D',
                      borderRadius: '20px',
                      padding: '4px 8px',
                      fontSize: '15px',
                      fontFamily: 'Roboto700',
                      color: '#FFF',
                    }}
                  >
                    {t('life.MakeRequest.contact.UnderReview')}
                  </div>
                )}
              </div>
            </BoldLabelFormItem>
          </Col> */}
          <Col xs={24} md={24}>
            <BoldLabelFormItem
              label={
                <span style={{ color: '#6f7072', fontWeight: 'normal', fontSize: '17px', fontFamily: 'Roboto500' }}>
                  {t('life.MakeRequest.payment.AutopayStatus')}
                </span>
              }
              name="AutopayStatus"
            >
              <div
                style={{
                  border: 'none',
                  borderBottom: '1px solid #CCCCCC',
                  // color: "white",
                  backgroundColor: 'transparent',
                  fontSize: '20px',
                  fontFamily: 'Roboto400',
                  marginBottom: '10px',
                  padding: '4px 0',
                  display: 'flex',
                  justifyContent: 'space-between',
                }}
              >
                <div style={{ width: form.getFieldValue('officeNumberFlag') === 'Y' ? (xs ? '70%' : '80%') : '100%' }}>
                  {isEnglish ? form.getFieldValue('AutopayStatus') : form.getFieldValue('AutopayStatusTc')}
                </div>
                {form.getFieldValue('officeNumberFlag') === 'Y' && (
                  <div
                    style={{
                      background: '#E9573D',
                      borderRadius: '20px',
                      padding: '4px 8px',
                      fontSize: '15px',
                      fontFamily: 'Roboto700',
                      color: '#FFF',
                      height: '31.5px',
                      // minWidth: '91px',
                    }}
                  >
                    {t('life.MakeRequest.contact.UnderReview')}
                  </div>
                )}
              </div>
            </BoldLabelFormItem>
          </Col>
        </Row>
      )}
      <Row justify="center" gutter={[16, { xs: 8, sm: 8, lg: 24 }]}>
        <Col xs={24} md={24}>
          <div
            style={{
              border: 'none',
              // color: "white",
              backgroundColor: 'transparent',
              fontSize: '17px',
              fontFamily: 'Roboto400',
              color: '#6F7072',
            }}
          >
            {t('life.MakeRequest.contact.FooterText')}
          </div>
        </Col>
        <Col xs={24} md={24}>
          <div
            style={{
              border: 'none',
              // color: "white",
              backgroundColor: 'transparent',
              fontSize: '17px',
              fontFamily: 'Roboto500',
              color: '#C21B17',
              textAlign: 'center',
              marginTop: '24px',
            }}
          >
            <span onClick={downloadPdf} style={{ cursor: 'pointer' }}>
              {t('life.MakeRequest.contact.FooterButton')}
              <img src={redright} style={{ margin: '0  2px 0 10px', width: '8px', height: '14px' }} />
            </span>
          </div>
        </Col>
      </Row>
    </div>
  );
};
